import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '服务项目', path: '/services' },
  { name: '美丽资讯', path: '/articles' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-xl md:text-2xl font-heading text-primary-500 font-bold">
              沙龙室
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.name}
                {isActive(link.path) && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-5 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            ))}
            <Link
              to="/about"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200"
            >
              预约体验
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label={isMobileOpen ? '关闭菜单' : '打开菜单'}
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          isMobileOpen ? 'max-h-80' : 'max-h-0'
        }`}
      >
        <div className="bg-background-50/95 backdrop-blur-md px-4 py-4 flex flex-col gap-3 border-t border-background-200/70">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium whitespace-nowrap cursor-pointer py-2 ${
                isActive(link.path)
                  ? 'text-primary-500'
                  : 'text-foreground-700'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="/about"
            className="bg-primary-500 text-background-50 text-center px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer"
          >
            预约体验
          </Link>
        </div>
      </div>
    </nav>
  );
}